import { render, staticRenderFns } from "./AdminSignupAlert.vue?vue&type=template&id=34567cda&scoped=true&"
import script from "./AdminSignupAlert.vue?vue&type=script&lang=js&"
export * from "./AdminSignupAlert.vue?vue&type=script&lang=js&"
import style0 from "./AdminSignupAlert.vue?vue&type=style&index=0&id=34567cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34567cda",
  null
  
)

export default component.exports